import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import StoreLayout from './components/layout/StoreLayout';
import AuthCallback from './pages/AuthCallback';
import Community from './pages/Community';
import Event from './pages/Event';
import GlobalSearchResult from './pages/GlobalSearchResult';
import Home from './pages/Home';
import Login from './pages/Login';
import MyInterest from './pages/MyInterest';
import MyPage from './pages/MyPage';
import PointShop from './pages/PointShop';
import StoreGoods from './pages/StoreGoods';
import StoreHome from './pages/StoreHome';
import StorePageDeliveryGoods from './pages/StorePageDeliveryGoods';
import StorePageNormalGoods from './pages/StorePageNormalGoods';

function App() {
  return (
    <Routes>
      {/* /store 하위 라우트에만 StoreLayout 적용 */}
      <Route path="/store" element={<StoreLayout />}>
        <Route index element={<Navigate to="/store/home" replace />} />
        <Route path="home" element={<StoreHome />} />
        <Route path="normal" element={<StorePageNormalGoods />} />
        <Route path="delivery" element={<StorePageDeliveryGoods />} />
        <Route path="myInterest" element={<MyInterest />} />
        <Route path="goods/:goodsSeq" element={<StoreGoods />} />
      </Route>
      {/* 나머지 라우트는 기존대로 */}
      <Route path="/search" element={<GlobalSearchResult />} />
      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/home" element={<Home />} />
      <Route path="/pointshop" element={<PointShop />} />
      <Route path="/community" element={<Community />} />
      <Route path="/event" element={<Event />} />
      <Route path="/mypage" element={<MyPage />} />
    </Routes>
  );
}

export default App;
